//import styled from 'styled-components';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { BsTelephoneFill } from "react-icons/bs";
import { useRef, useState } from 'react';
import { MSG_TYPE_ENUM } from './Message';
import { Timestamp } from 'firebase/firestore';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import { createRef } from 'react';
import { url } from './firebase';
import { LIMITS } from '../Limits';
const { EMAIL_VISITOR } = MSG_TYPE_ENUM;

export default function ContactModule({ config, name, email, addMessage }) {

    const { contactModuleSettings } = config;
    const nameRef = useRef(name || "");
    const emailRef = useRef(email || "");
    const messageRef = useRef("");
    const [emailError, setEmailError] = useState("");
    const [isEmailSent, setIsEmailSent] = useState(false);
    const recaptchaRef = createRef();

    // Check if at least one contact method is enabled and not empty
    const hasValidAddress = contactModuleSettings?.addressEnabled && contactModuleSettings?.address;
    const hasValidPhone = contactModuleSettings?.phoneNumberEnabled && contactModuleSettings?.phoneNumber;
    const hasValidEmail = contactModuleSettings?.displayEmailEnabled && contactModuleSettings?.displayEmail;
    
    const hasEnabledContactMethod = hasValidAddress || hasValidPhone || hasValidEmail;

    async function handleSubmit(e) {
        e.preventDefault();
        if (config?.contactModuleSettings?.enableRecaptcha) {
            const recaptchaValue = recaptchaRef.current.getValue();
            if (!recaptchaValue || !config?.workspace || !config?.registeredUser) {
                setEmailError("Please complete the reCAPTCHA verification.");
                return;
            }
            try {
                const response = await axios.get(`${url}/email/recaptcha?token=${recaptchaValue}&workspace=${config?.workspace}&uid=${config?.registeredUser}`);
                if (!response.data.success) {
                    setEmailError("reCAPTCHA verification failed. Please try again.");
                    return;
                }
                } catch (error) {
                    console.error('Error verifying reCAPTCHA:', error);
                    setEmailError("An error occurred during reCAPTCHA verification. Please try again.");
                    return;
                }
        }
        const message = {
            clientInbox: config?.contactModuleSettings?.inboxEmail,
            sendYGM: config?.contactModuleSettings?.enableYouGotMailMessage || false,
            name: nameRef.current.value,
            email: emailRef.current.value,
            message: messageRef.current.value,
            msgType: EMAIL_VISITOR,
            createdAt: Timestamp.now(),
            seen: true,
        };
        addMessage(message);
        setIsEmailSent(true);
    }
    return (
        <div className='page-container'>
            <div className='scrollable-container'>
                {config?.contactModuleSettings?.title && <div className='contact-title'>{ config?.contactModuleSettings?.title?.length > LIMITS.title ? "Error" : config?.contactModuleSettings?.title }</div>}
                <div className='contact-flex-container'>
                    {hasEnabledContactMethod && (
                        <div className='contact-section'>
                            <div className='contact-card'>
                                <div className='contact-info'>
                                    {hasValidAddress && (
                                        <div className='contact-item'>
                                            <div className='contact-item-container'>
                                                <FaMapMarkerAlt />
                                                <strong>Address: </strong>
                                            </div>
                                            {contactModuleSettings?.address.length > LIMITS.address ? "Error" : contactModuleSettings?.address}
                                        </div>
                                    )}
                                    {window.innerWidth > 775 && (
                                        <>
                                            {hasValidPhone && (
                                                <div className='contact-item'>
                                                    <div className='contact-item-container'>
                                                        <BsTelephoneFill />
                                                        <strong>Phone: </strong>
                                                    </div>
                                                    {contactModuleSettings?.phoneNumber.length > LIMITS.phoneNumber ? "Error" : contactModuleSettings?.phoneNumber}
                                                </div>
                                            )}
                                            {hasValidEmail && (
                                                <div className='contact-item'>
                                                    <div className='contact-item-container'>
                                                        <FaEnvelope />
                                                        <strong>Email: </strong>
                                                    </div>
                                                    {contactModuleSettings?.displayEmail.length > LIMITS.displayEmail ? "Error" : contactModuleSettings?.displayEmail}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                {window.innerWidth <= 775 && (
                                    <div className='contact-button-group'>
                                        {hasValidPhone && (
                                            <div className='contact-outline-button' href={`tel:${contactModuleSettings?.phoneNumber}`}>
                                                <div className='contact-item-container'>
                                                    <BsTelephoneFill />
                                                    <strong>Call</strong>
                                                </div>
                                            </div>
                                        )}
                                        {hasValidEmail && (
                                            <div className='contact-outline-button' href={`mailto:${contactModuleSettings?.displayEmail}`}>
                                                <div className='contact-item-container'>
                                                    <FaEnvelope />
                                                    <strong>Email</strong>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className='contact-section'>
                        <div className='contact-card'>
                            {isEmailSent? <p style={{ textAlign: 'center' }}>Your email has been sent!</p> :
                            <form className='contact-form' onSubmit={handleSubmit}>
                                <div className='contact-form-group'>
                                    <label className='contact-label' htmlFor="email">Your Email</label>
                                    <input className='contact-input' type="email" id="email" placeholder="example@email.com" ref={emailRef} required />
                                </div>
                                <div className='contact-form-group'>
                                    <label className='contact-label' htmlFor="name">Name</label>
                                    <input className='contact-input' type="text" id="name" placeholder="John Doe" ref={nameRef} required />
                                </div>
                                <div className='contact-form-group'>
                                    <label className='contact-label' htmlFor="message">Message</label>
                                    <textarea className='contact-textarea' id="message" rows={3} placeholder="Enter your message" ref={messageRef} required />
                                </div>
                                {/* DISABLED RECAPTCHA FOR VISUALIZATION */}
                                {/* config?.contactModuleSettings?.enableRecaptcha && config?.contactModuleSettings?.recaptchaPublicKey && <ReCAPTCHA
                                    sitekey={config?.contactModuleSettings?.recaptchaPublicKey}
                                    ref={recaptchaRef}
                                    size='normal'
                                    style={{ margin:'10px auto' }}
                                />} */}
                                {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                <button className='contact-button' type="submit">Send Email</button>
                            </form>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}